import { ModuleWithProviders} from '@angular/core';
import {Routes, RouterModule } from '@angular/router';

import { UserListComponent } from './user-list.component'

const USER_LIST_ROUTES: Routes = [{
    path: '', component: UserListComponent
}];

export const USER_LIST_ROUTING  = RouterModule.forChild(USER_LIST_ROUTES);